import { OptOutReasons } from 'application/account/optOutReasons'
import { adminHttpClient } from '../commons/adminHttpClient'

export type UpdateOptOutReasonRequest = {
  planPeriodId: string
  companyUserId: string
  optOutReason: OptOutReasons
}
const updateOptOutReason = (request: UpdateOptOutReasonRequest): Promise<void> => {
  return adminHttpClient.post(`/EEDashboard/UpdateOptOutReason`, request)
}

export default updateOptOutReason
